import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../environments/environment';

const SUPPORTED: string[] = ['en', 'fr'];
const STORAGE_KEY = 'locale';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  constructor(private http: HttpClient, private translate: TranslateService) {}

  getLocale(): string {
    const stored = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED.includes(stored ?? '') ? stored! : 'en';
  }

  setLocale(locale: string): void {
    if (!SUPPORTED.includes(locale)) { return; }
    localStorage.setItem(STORAGE_KEY, locale);
    this.http.post(`${environment.apiUrl}/api/v1/locale/switch`, { locale }).subscribe({
      next: () => window.location.reload(),
      error: () => window.location.reload(),
    });
  }

  syncLocale(): void {
    const locale = this.getLocale();
    this.translate.use(locale);
    if (locale !== 'en') {
      this.http.post(`${environment.apiUrl}/api/v1/locale/switch`, { locale }).subscribe();
    }
  }

  availableLocales(): { code: string; label: string; countryCode: string }[] {
    return [
      { code: 'en', label: 'English', countryCode: 'gb' },
      { code: 'fr', label: 'Français', countryCode: 'fr' },
    ];
  }
}
